import script from "./Attendence.vue?vue&type=script&setup=true&lang=js"
export * from "./Attendence.vue?vue&type=script&setup=true&lang=js"

import "./Attendence.vue?vue&type=style&index=0&id=6b34d605&lang=scss"

const __exports__ = script;

export default __exports__